import UsersModel, { UserForm, UsersFilters } from "../models/users.model";
import { User } from "../types/users";
import { useReducerAsState } from "./useReducerAsState";

interface State {
    users: Array<User>;
    loading: boolean;
    error: string;
    totalUsers: number;
    user: User | null;
}

const useUsers = () => { 
    const [state, setState] = useReducerAsState<State>({
        users : [],
        loading: false,
        error: "",
        totalUsers: 0,
        user: null
    });

    const { user, users, totalUsers, loading, error } = state;

    const fetchUsers = async (filters: UsersFilters
    ) => {
        setState({loading: true, error:"", totalUsers: 0})
        const response = await UsersModel.getAll(filters);
        if(response.error){
            setState({users:[], loading: false, error:"", totalUsers: 0})
            return
        }

        setState({users:response.users!.data, totalUsers: response.total, loading: false, error:""})
    }

    const findUser = async (userId: number) => {
        setState({loading: true, error:""})
        const response = await UsersModel.find(userId);
        if(response.error){
            setState({users:[], loading: false, error:"", user: null})
            return
        }

        setState({user: response.users?.data[0], loading: false, error:""})
    }

    const createUser = async (data : UserForm) => {
        setState({loading: true, error:""})
        const response = await UsersModel.create(data);
        if(response.error){
            setState({users:[], loading: false, error:"", user: null})
            return false
        }

        setState({ loading: false, error:""})
        return true
    }

    const updateUser = async (userId: number, data : UserForm) => {
        setState({loading: true, error:""})
        const response = await UsersModel.update(userId, data);
        if(response.error){
            setState({users:[], loading: false, error:response.error, user: null})
            return false
        }

        setState({loading: false, error:""})
        return true
    }

    const deleteUser = async (userId: number): Promise<boolean> => {
        setState({loading: true, error:""})
        const response = await UsersModel.delete(userId);
        if(response.error){
            setState({users:[], loading: false, error:response.error})
            return false
        }

        setState({loading: false, error:""})
        return true
    }

    return {
        user,
        users,
        totalUsers,
        loading, 
        fetchUsers,
        findUser,
        createUser,
        updateUser,
        error,
        deleteUser
    }
}

export default useUsers;